export default __webpack_public_path__ + "../staticImages/novosales_logo.png";